import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import noAuth401 from "@/components/401"
import noAuth403 from "@/components/403"
import noFind404 from "@/components/404"
import error501 from "@/components/501"
import YHLogin from "@/components/login/index";
import ForgotPassword from '@/components/login/forgotpwd';
import HomePage from '@/components/home/home';
import ChangePassword from '@/components/login/changepwd';
import FoodsList from '@/components/foods/foodslist';
import CouponsMng from '@/components/coupons/couponsmng';
import CustomerCouponList from '@/components/customercoupon/customercouponlist';
import TodayOrders from '@/components/orders/todayorders';
import HistoryOrders from '@/components/orders/historyorders';
import BusinessList from '@/components/business/businesslist';
import StallList from '@/components/stall/stalllist';
import ShopUserList from '@/components/shopuser/shopuserlist';
import SysConfigList from '@/components/system/sysconfiglist';
import RefundOrderList from '@/components/refundorder/refundorderlist';
import OrderSaleList from '@/components/report/ordersalelist';
import DeliveryDetail from '@/components/report/deliverydetail';
import CabsList from '@/components/cabinets/cabinetmng';

export default new Router({
	routes: [
		{
			path: "/",
			name: "Login",
			component: YHLogin,
			//props: route => ({
			//}),
			meta: {
				requireLogin: false,
				requireAuth: false
			}
		},
		{
			path: "/forgot",
			name: "ForgotPassword",
			component: ForgotPassword,
			//props: route => ({
			//}),
			meta: {
				requireLogin: false
			}
		},
		{
			path: "/home",
			name: "Home",
			component: HomePage,
			//props: route => ({
			//}),
			meta: {
				requireLogin: true
			},
			redirect: '/TodayOrders',//页面默认加载的路由
			children: [
				{
					path: "/FoodsList",
					name: "FoodsList",
					component: FoodsList,
					//props: route => ({
					//}),
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/CouponsMng",
					name: "CouponsMng",
					component: CouponsMng,
					//props: route => ({
					//}),
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/CustomerCouponList",
					name: "CustomerCouponList",
					component: CustomerCouponList,
					//props: route => ({
					//}),
					meta: {
						requireLogin: true
					}
				},				
				{
					path: "/HistoryOrders",
					name: "HistoryOrders",
					component: HistoryOrders,
					//props: route => ({
					//}),
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/TodayOrders",
					name: "TodayOrders",
					component: TodayOrders,
					//props: route => ({
					//}),
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/businesslist",
					name: "businesslist",
					component: BusinessList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/stalllist",
					name: "stalllist",
					component: StallList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/shopuserlist",
					name: "shopuserlist",
					component: ShopUserList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/sysconfiglist",
					name: "sysconfiglist",
					component: SysConfigList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/refundorderlist",
					name: "refundorderlist",
					component: RefundOrderList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/ordersalelist",
					name: "ordersalelist",
					component: OrderSaleList,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/deliverydetail",
					name: "deliverydetail",
					component: DeliveryDetail,
					meta: {
						requireLogin: true
					}
				},
				{
					path: "/cabslist",
					name: "cabslist",
					component: CabsList,
					meta: {
						requireLogin: true
					}
				},
			]
		},
		{
			path: "/changpwd",
			name: "ChangePassword",
			component: ChangePassword,
			//props: route => ({
			//}),
			meta: {
				requireLogin: true
			}
		},
		{
			path: "/noAuth401",
			name: "noAuth401",
			component: noAuth401
		},
		{
			path: "/noAuth403",
			name: "noAuth403",
			component: noAuth403
		},
		{
			path: "/noFind404",
			name: "noFind404",
			component: noFind404
		},
		{
			path: "/error501",
			name: "error501",
			component: error501
		}
	]
});